module.exports = __webpack_public_path__ + "static/img/作品12.5d0509f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品12.png
// module id = qm5n
// module chunks = 1